/**
 * Async function that waits for a given amount of time
 * @example
 * ```ts
 * await wait(1000)
 * ```
 */
export const wait = (ms: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms))
